export default __webpack_public_path__ + "static/media/logout_black.53238ed3.svg";